import {
  EssenceItemDto,
  EssencesApi,
  ProductDto
} from '@eurogast/hub-client-typescript';
import { ApiService } from '@/services/ApiService';
import { ConfigService } from '@/services/ConfigService';

export default class EssenceApiService {
  private static instance: EssenceApiService = null;

  public static singleton(): EssenceApiService {
    if (this.instance == null) {
      this.instance = new EssenceApiService();
    }

    return this.instance;
  }

  private essenceApi: EssencesApi;

  private constructor() {
    this.essenceApi = ApiService.wrap(EssencesApi);
  }

  public async fetchEssenceMap(products: ProductDto[]): Promise<Map<string, EssenceItemDto[]>> {
    const essenceItems = await this.essenceApi.getLastThreeEssenceItemsFromList(
      ConfigService.getTenant(),
      ConfigService.currentCustomerIdOrNull,
      products.map((el) => el.sku)
    );
    const essenceItemsBySku = new Map<string, EssenceItemDto[]>();

    for (const item of essenceItems) {
      if (!essenceItemsBySku.has(item.sku)) {
        essenceItemsBySku.set(item.sku, []);
      }

      essenceItemsBySku.get(item.sku).push(item);
    }

    return essenceItemsBySku;
  }
}
